import React from 'react';
import { Center, Icon, Text, VStack } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

interface EmptyStateProps {
  message: string;
  icon?: React.ReactElement;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
  message, 
  icon = <Icon as={WarningIcon} w={10} h={10} color="orange.500" />
}) => {
  return (
    <Center py={10}>
      <VStack spacing={4}>
        {icon}
        <Text>{message}</Text>
      </VStack>
    </Center>
  );
};
